import { t } from 'components/CentralDataMangement/translation/Translation';
import type { ReactNode } from 'react';
import type React from 'react';
import type { ToastOptions} from 'react-toastify';
import { toast, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export type NotifyType = 'success' | 'error' | 'warning';

interface CustomNotifyProps {
  type?: NotifyType;
  message?: string | boolean | ReactNode;
  autoClose?: number | false;
}

const CustomNotify: React.FC<CustomNotifyProps> = ({ type = 'success', message, autoClose = 1500 }) => {
  const toastOptions: ToastOptions = {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: autoClose,
    transition: Zoom,
  };

  // Check the type and display toast accordingly
  if (type === 'success') {
    toast.success(message || t('Logged in successfully!'), toastOptions);
  } else if (type === 'error') {
    toast.error(message || t('An error occurred!'), toastOptions);
  } else if (type === 'warning') {
    toast.warning(message || t('Some warning!'), toastOptions);
  }

  // Return null as this component does not render anything
  return null;
};

export default CustomNotify;
